import React, { useState } from 'react';
import axios from 'axios';
import './Chat.css'; // Ensure this file contains the CSS rules for the new styles

const Chat = () => {
  const [question, setQuestion] = useState('');
  const [conversation, setConversation] = useState([]); // State to hold the conversation history
  const [isLoading, setIsLoading] = useState(false); // State to manage loading status

  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!question.trim()) {
      return;
    }

    setIsLoading(true); // Start loading

    // Add user question to conversation history
    setConversation((prevConversation) => [
      ...prevConversation,
      { sender: 'user', text: question },
    ]);

    try {
      const res = await axios.post('https://supabase-hackthon.onrender.com/api/v1/chat/askQuestion', { question });

      if (res.status === 200) {
        setConversation((prevConversation) => [
          ...prevConversation,
          { sender: 'bot', text: res.data.response },
        ]);
      } else {
        setConversation((prevConversation) => [
          ...prevConversation,
          { sender: 'bot', text: 'Failed to get a response.' },
        ]);
      }
    } catch (error) {
      console.error('Error submitting question:', error);
      setConversation((prevConversation) => [
        ...prevConversation,
        { sender: 'bot', text: 'An error occurred while processing your question.' },
      ]);
    } finally {
      setIsLoading(false); // Stop loading
    }

    // Clear the question input field
    setQuestion('');
  };

  return (
    <div className="chat-container"> {/* Apply CSS styles */}
      <h2>Chat with Our Support Bot</h2>
      
      {/* Conversation history */}
      <div className="chat-history">
        {conversation.map((msg, idx) => (
          <div
            key={idx}
            className={`chat-message ${msg.sender}`}
          >
            {msg.text}
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="chat-form">
        <input
          type="text"
          id="question"
          value={question}
          onChange={handleQuestionChange}
          className="chat-input"
          placeholder="Type your question..."
        />
        <button type="submit" className="chat-submit">
          {isLoading ? 'Sending...' : 'Send'}
        </button>
      </form>
    </div>
  );
};

export default Chat;
